import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { AvalesService } from '../../../services/avales.service';
import { ArchivosAvalComponent } from './components/archivos-aval/archivos-aval.component';

@Component({
  selector: 'formulario-aval',
  templateUrl: './formulario-aval.component.html'
})
export class FormularioAvalComponent implements OnInit {
    @ViewChild('archivosAval') archivosAval: ArchivosAvalComponent;

    @Input() public idCreditos : number = null;
    @Input() public isEditable: boolean = false;
    @Input() public aval: any = {};

    @Output() public onDataUpdated: EventEmitter<string> = new EventEmitter;
    @Output() public onAvalDeleted: EventEmitter<void> = new EventEmitter;
    //Avales form
    public formId: number = 0;
    public errors: any = {};
    public temporalName: string = '';
    public isNewAval: boolean = false;

    constructor(
      private helperService: HelpersService,
      private avalesService : AvalesService
    ){
    }

    ngOnInit() {
      //formId se asigna con un valor 'unico' para utilizar como id, en algún coponente del front
      this.formId = + new Date();

      if(this.aval.id){
        this.temporalName = this.aval.nombre;
      }else {
        //Cuando es un nuevo aval, el componente se muestra expandido. Sabemos que es nuevo porque no tiene valor en la propiedad id
        this.isNewAval = true;
        this.temporalName = "Nuevo aval"
      }
    }

    public save(){
        this.errors = {};

        let aval = this.aval;
        //Asigna el tipo de Crédito. Ya que hay campos que no se requieren para todos los créditos
        this.errors = this.avalesService.validate(aval);

        if (Object.entries(this.errors).length > 0) {
          return false;
        }

        //Si no se selecciono el aval como principal, el campo es_principal debe tener el valor de false
        if(this.aval.es_principal === undefined || this.aval.es_principal === null){
          this.aval.es_principal = false;
        }

        if(aval.id && aval.id > 0){
            //Actualiza la información
            this.update(aval);
        }else{
            //Crear por primera vez el registro referente al avaluo 
            aval.idCreditos = this.idCreditos;
            this.create(aval);
        }      
    }

    private create(aval: any){
        this.avalesService.save(aval).subscribe(
            (response)=>
            {
              this.aval.id = response.json().content.id;
              //Si se agregaron archivos al Aval, entes de que este seguardará en la BD, se debe asignar el IdAval a estos archivos
              this.archivosAval.setIdAval(this.aval.id);
              //Notifica que hubo cambios en los avales
              this.onDataUpdated.emit();

              this.helperService.notification('Aval actualizado', 'Se ha actualizado exitosamente la información del aval ', 'success');
            }, error =>
            {
              // se resuelve error 403 y 500
              this.helperService.httpGlobalError(error);
      
              if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
              }
            }
        );
    }

    private update(aval: any){
        this.avalesService.update(aval).subscribe(
          (response)=>
          {
            this.helperService.notification('Aval actualizado', 'Se ha actualizado exitosamente la información del aval ', 'success');
            this.onDataUpdated.emit();
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }

    public eliminar(){
      if(this.aval.id){
        //Si ya fue gurdado en la BD es necesario eliminarlo
        this.eliminarRegistro(this.aval.id)
      }else{
        this.onAvalDeleted.emit();
      }
    }

    public eliminarRegistro(idAval: number){
      this.avalesService.delete(idAval).subscribe(
        (response)=>
        {
          this.helperService.notification('Aval eliminado', 'Se ha eliminado exitosamente la información del aval ', 'success');
          this.onAvalDeleted.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    //Acualizar el título del Aval, con el nombre que fue ingresado
    public updateTemporalName() {
      this.temporalName = this.aval.nombre;
    }
}



// WEBPACK FOOTER //
// ./src/app/creditos/components/formulario-aval/formulario-aval.component.ts